import { render } from "./AntragstellerVertretungsberechtigter.pug?vue&type=template&id=3b9aa53b&lang=pug"
import script from "./AntragstellerVertretungsberechtigter.js?vue&type=script&lang=js"
export * from "./AntragstellerVertretungsberechtigter.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__